export class FieldBuilder {
    private selections: Set<string> = new Set(['id']); // Always include ID
    private includes: Map<string, FieldBuilder> = new Map();
  
    select(field: string): this {
      this.selections.add(field);
      return this;
    }
  
    include(relation: string, builder?: (field: FieldBuilder) => void): this {
      const relationBuilder = new FieldBuilder();
      if (builder) {
        builder(relationBuilder);
      }
      this.includes.set(relation, relationBuilder);
      return this;
    }
  
    buildSelection(): string {
      const fields = Array.from(this.selections);
      const includes = Array.from(this.includes.entries()).map(([relation, builder]) => {
        return `${relation} { ${builder.buildSelection()} }`;
      });
      
      return [...fields, ...includes].join(' ');
    }
  }